import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';

class PlayersSearch extends Component {
    onSearchPlayerName(e) {
        this.props.dispatch(Action.do('filterByPlayerName', e.target.value));
    }

    render() {
        const {playersFilter} = this.props;

        return (
            <div className="search-player">
                <input
                    type="text"
                    placeholder="Find Player"
                    className="form-control"
                    value={playersFilter.playerName}
                    onChange={(e) => ::this.onSearchPlayerName(e)}
                />
                <i className="fa fa-search"></i>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {players, filters: playersFilter} = state.playersData;

    return {
        players,
        playersFilter,
    };
}

export default connect(mapStatesToProps)(PlayersSearch);
